var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLevel3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6001 9.63594C1.6001 9.19411 1.95827 8.83594 2.4001 8.83594H4.0001C4.44193 8.83594 4.8001 9.19411 4.8001 9.63594V13.6359C4.8001 14.0778 4.44193 14.4359 4.0001 14.4359H2.4001C1.95827 14.4359 1.6001 14.0778 1.6001 13.6359V9.63594Z",
    fill: "#fff",
    stroke: "#AAAAAA",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6499 6.43574C6.6499 6.13199 6.89615 5.88574 7.1999 5.88574H8.7999C9.10366 5.88574 9.3499 6.13199 9.3499 6.43574V13.6357C9.3499 13.9395 9.10366 14.1857 8.7999 14.1857H7.1999C6.89615 14.1857 6.6499 13.9395 6.6499 13.6357V6.43574Z",
    fill: "#fff",
    stroke: "#AAAAAA",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4502 4.03633C11.4502 3.73257 11.6964 3.48633 12.0002 3.48633H13.6002C13.904 3.48633 14.1502 3.73257 14.1502 4.03633V13.6363C14.1502 13.9401 13.904 14.1863 13.6002 14.1863H12.0002C11.6964 14.1863 11.4502 13.9401 11.4502 13.6363V4.03633Z",
    fill: "#fff",
    stroke: "#AAAAAA",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLevel3);
export default __webpack_public_path__ + "static/media/icon-level-3.98bc2b057934e8a30128d9f6334d9bb6.svg";
export { ForwardRef as ReactComponent };